var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.135 24.255L34.68 33.18C34.425 35.25 31.86 36 30.165 36H20.7C20.4 36 20.13 35.925 19.905 35.79L17.745 34.5H15.165C13.575 34.5 12.165 33.09 12.165 31.5V25.5C12.165 23.91 13.575 22.47 15.165 22.5H18.165C19.53 22.5 20.25 21.825 21.75 20.175C23.115 18.675 23.07 17.475 22.695 15.27C22.575 14.52 22.785 13.77 23.325 13.14C23.91 12.435 24.795 12 25.665 12C28.41 12 30.165 17.565 30.165 19.515L30.135 20.985H33.195C34.935 20.985 36.12 22.185 36.165 23.94C36.165 24.105 36.135 24.255 36.135 24.255ZM33.18 22.47H30.195C29.145 22.47 28.65 22.05 28.65 21.015L28.695 19.47C28.695 17.565 26.94 13.47 25.695 13.47C24.945 13.47 24.075 14.22 24.195 14.97C24.57 17.34 24.705 19.14 22.86 21.18C21.33 22.875 20.205 24 18.165 24V33L20.67 34.5H30.165C31.26 34.5 33.09 34.035 33.165 33L33.195 32.97L34.695 23.97C34.65 23.01 34.125 22.47 33.195 22.47H33.18Z",
    fill: "#25855A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.665039,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#25855A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutline);
export default __webpack_public_path__ + "static/media/like-outline.a2c2fee81ed4d0d4b0e193297139b5ce.svg";
export { ForwardRef as ReactComponent };